<script>
import { delay } from '@triascloud/utils';
import {
  Component,
  Vue,
  PropSync,
  Prop,
  InjectReactive,
} from 'vue-property-decorator';
import {
  createRandom,
  parseVariable,
  ControlTypeEnum,
  PARAM_STATUS,
  PARAM_TYPE,
} from './utils';

@Component()
export default class RenderNumber extends Vue {
  @PropSync('item') syncItem;
  @PropSync('store') syncStore;
  @Prop() tooltip;
  @Prop() param;
  @Prop() checkDefaultValue;
  @Prop() schemeByType;
  @Prop({ type: String, default: 'id' }) useKey;

  @InjectReactive('variables') variables;

  random;
  async created() {
    this.random = Math.random();
    if (/\{\{(\w+)\}\}/.test(this.syncStore.get(this.syncItem[this.useKey]))) {
      const strValue = parseVariable(
        this.syncStore.get(this.syncItem[this.useKey]),
        this.variables,
      );
      await this.$nextTick();
      await delay(50);
      this.syncStore.set(this.syncItem[this.useKey], strValue);
    }
  }

  renderRandom() {
    const item = this.syncItem;
    this.checkDefaultValue(item);
    let str;
    if (item.type === ControlTypeEnum.Input) {
      let data = createRandom(item, this.random);

      if (data) {
        this.syncStore.set(item[this.useKey], data);
      }
      // eslint-disable-next-line prettier/prettier
      str = <a-input v-model={this.syncStore.data[item[this.useKey]]} />;
    } else {
      str = (
        <a-input-number
          style={{ width: '100%' }}
          v-model={this.syncStore.data[item[this.useKey]]}
        />
      );
    }
    return str;
  }

  render() {
    const item = this.syncItem;
    this.checkDefaultValue(item);
    return (
      <a-form-model-item
        class={this.$style.formItem}
        rules={[
          { required: item.required, message: '不能为空', trigger: 'blur' },
        ]}
        prop={item[this.useKey]}
      >
        {item[PARAM_TYPE] === PARAM_STATUS.IN ? (
          <a-row class={this.$style.labelHeader}>
            <a-col span={6}>
              <label class={item.required ? 'ant-form-item-required' : ''}>
                {item.name}
              </label>
            </a-col>
            <a-col span={4}>{item.type}</a-col>
            <a-col span={14}>{this.renderRandom()}</a-col>
          </a-row>
        ) : (
          <div>
            <span
              class={[
                this.$style.label,
                item.required ? 'ant-form-item-required' : '',
              ]}
            >
              <span>{item.name}</span>
              {this.tooltip(item)}
              {this.param(item)}
            </span>
            {this.renderRandom()}
          </div>
        )}
      </a-form-model-item>
    );
  }
}
</script>
<style lang="less" module>
.formItem {
  :global {
    .ant-form-item-required {
      display: flex;
      align-items: center;
    }
  }
}
.label {
  display: flex;
  align-items: center;
}
.labelHeader {
  height: 50px;
  display: flex;
  align-items: center;
  border-top: 1px solid var(--border);
}
</style>
